<template>
    <div class="flex_content">

        <div id="context_bar">
            <TopbarGoPositionsList />
        </div>

        <titlePage>
            <template slot="titleBody">
                <h1 class="page-title title is-size-1" >Team Fit </h1>
                <h2 class="associated_ref_name" v-if="currentRef"><span>{{ currentPosition.name }}</span></h2>
                <h2 class="associated_ref_name" v-if="currentRef"><span>{{ refName }}</span></h2>
            </template>
        </titlePage>
        <div class="team_fit_components" v-if="dataLoaded">
            <TeamFitRefForm v-if="currentStep == 'scores_form'" :evaluations="evaluations" :currentRef="currentRef" @ScoreValidated="changeStep"></TeamFitRefForm>
            <TeamFitRefName v-if="currentStep == 'title_ref_form'" :teamRef="teamRef" @refSaved="changeStep"></TeamFitRefName>
            <TeamFitRefSaved v-if="currentStep == 'refSaved'" :teamRef="teamRef" ></TeamFitRefSaved>
            
        </div>
        

    </div>

</template>

<script>
import TitlePage from "@/components/layouts/titlePage"
import TopbarGoPositionsList from "../components/topbar/topbarGoPositionsList"
import TeamFitRefForm from "../components/teamFit/teamFitRefForm"
import TeamFitRefName from "../components/teamFit/teamFitRefName"
import TeamFitRefSaved from "../components/teamFit/teamFitRefSaved"



export default {
    name: 'PositionTeamFit',
    components: {
        TitlePage,
        TopbarGoPositionsList,
        TeamFitRefForm,
        TeamFitRefName,
        TeamFitRefSaved
    },
    created(){
        this.$store.dispatch('PositionStore/getPosition', this.$route.params.id).then(() => {
            const queryData = {
                position_id: this.currentPosition.id,
                sort_column: "matching_score",
                sort_type: 'DESC',
                only_completed: 1,
                current_page: 1,
                item_per_page: 20 
            }
            this.$store.dispatch('PositionStore/getPositionEvals', queryData).then(() => {})
        })
    },
    data(){
        return {
            currentStep: "scores_form",
            firstScoresMap: ["r1", "r2", "r8", "r9"],
            middleScoresMap: ["r10", "r11", "r12", "r13", "r14", "r15", "r16", "r17"],
            lastScoresMap: ["r3", "r4", "r5", "r6", "r7"],
            selectedFriend1: null,
            selectedFriend2: null,
            teamRef: {},
            dims: {"r1": 0, "r2": 0, "r3": 0, "r4": 0, "r5": 0, "r6": 0, "r7": 0, "r8": 0, "r9": 0, "r10": 0, "r11": 0, "r12": 0, "r13": 0, "r14": 0, "r15": 0, "r16": 0, "r17": 0}
        }
    },
    computed: {
        currentPosition(){
            return this.$store.state.PositionStore.currentPosition
        },
        dimensionsPlan(){
            return this.currentPosition.dimensions_plan
        },
        evaluations(){
            return this.$store.state.PositionStore.PositionEvals
        },
        currentRef(){
            return this.currentPosition.sight_ref
        },
        dataLoaded(){
            return this.evaluations.length > 0
        },
        refName(){
            if(this.currentRef){
                return this.currentRef.job_titles[this.$i18n.locale]
            }else{
                return ""
            }
        }
    },
    methods: {
        changeStep(step, teamRef){
            console.log(teamRef)
            this.currentStep = step
            this.teamRef = teamRef
        }
    }
}
</script>

<style lang="scss" >
#index_eval_content{
    background: $white;
}
.eval_tabs{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: stretch;
    background-color: $white;
}
.position_evals_pagination{
    background: white;
}
.tabs_content{
    padding-bottom: 20px;
}
.evaluations_loader_container{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
    .evaluations_loader{
        width: 50px;
        fill: $info;
    }
}
.show_compare_chart_container{
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}
</style>
